import {AbstractModel} from '../abstract-model';
import {AvailableDomain} from '../cms/available-domain';

export class RedirectRule extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  domain: AvailableDomain | null = null;
  identifier: string | null = null;
  redirectUrl: string | null = null;
  copyQueryParameters: boolean = false;
  hitCount: number = 0;
  enabled: boolean = true;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.domain) {
      this.domain = new AvailableDomain().deserialize(input.domain);
    }

    return this;
  }
}
